import React from "react";
import { Container } from "react-bootstrap";
import { jwtDecode } from "jwt-decode";

interface JwtPayload {
    userType: string;
}
const Footer = () => {
     const token = localStorage.getItem('authUser')
    let decoded: any = "";
    if (token !== null) {
         decoded = jwtDecode<JwtPayload>(token);
    
      } else {
        console.error('Token is null');
      }
    const brandName = decoded.userType === 'homeowner'
        ? 'RELiBUILD'
        : "The Tradesmen's Collective";

    return (
        <React.Fragment>
            <footer className="footer modern-footer">
                <Container fluid>
                    <span className="modern-footer__copyright">© {new Date().getFullYear()} {brandName}. All rights reserved.</span>
                </Container>
            </footer>
        </React.Fragment>
    )
}

export default Footer;
